// extracted by mini-css-extract-plugin
export var contact = "contact-module--contact--3u4P2";
export var contactInfo = "contact-module--contact-info--30TCf";
export var contactInner = "contact-module--contact-inner--7FFl5";